(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

window.addEventListener('DOMContentLoaded', function () {
  var programFamilyForm = '#BrochureV2Type_IdFamilyProgram';
  var programForm = '#BrochureV2Type_IdProgram';
  var campusForm = '#BrochureV2Type_IdCampus';
  var programFamilySelect = document.querySelector(programFamilyForm);
  var programFamilySelect2 = $(programFamilySelect).select2();
  var programFamilyChoices = Array.from(document.querySelectorAll(programFamilyForm + ' option'));
  var programSelect = document.querySelector(programForm);
  var programSelect2 = $(programSelect).select2();
  var programChoices = Array.from(document.querySelectorAll(programForm + ' option'));
  var campusSelect = document.querySelector(campusForm);
  var campusSelect2 = $(campusSelect).select2();
  var campusChoices = Array.from(document.querySelectorAll(campusForm + ' option'));

  var changeCampus = function changeCampus(programValue) {
    // Hide campuses which are not children of the program
    var visibleCampusChoices = campusChoices.filter(function (campusChoice) {
      if (campusChoice.dataset.parentPrograms) {
        var datasetArray = JSON.parse(campusChoice.dataset.parentPrograms); //campusSelect2.next().find('.select2-selection').removeClass('completed')

        if (datasetArray.includes(programValue)) {
          campusChoice.classList.remove('hide');
          campusChoice.removeAttribute('disabled');
          return true;
        } else {
          campusChoice.classList.add('hide');
          campusChoice.setAttribute('disabled', 'disabled');
          return false;
        }
      }
    }); // Retrieve the visible choices in the program formgroup

    if (visibleCampusChoices.length > 0) {
      var campusChangeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      visibleCampusChoices[0].dispatchEvent(campusChangeEvent);
    } else {
      // If there is no choice available, then uncheck the selected choice to avoid form validation with invalid values
      document.querySelector(campusForm + ' option:checked').selectedIndex = false;
    }
  }; // Program family inputs event listener


  programFamilySelect2.on('change', function (evt) {
    var choosenProgramFamilyId = evt.target.value; // Hide programs which are not children of the program family

    var visibleProgramChoices = programChoices.filter(function (programChoice) {
      if (programChoice.dataset.parentFamily === choosenProgramFamilyId) {
        programChoice.classList.remove('hide');
        programChoice.removeAttribute('disabled');

        if (programChoice.parentNode.tagName === "OPTGROUP") {
          programChoice.parentNode.classList.remove('hide');
          programChoice.parentNode.removeAttribute('disabled');
        }

        return true;
      } else {
        if (programChoice.parentNode.tagName === "OPTGROUP") {
          programChoice.parentNode.classList.add('hide');
          programChoice.parentNode.setAttribute('disabled', 'disabled');
        }

        programChoice.classList.add('hide');
        programChoice.setAttribute('disabled', 'disabled');
        return false;
      }
    }); // Retrieve the visible choices in the program formgroup

    if (visibleProgramChoices.length > 0) {
      visibleProgramChoices[0].classList.remove('hide');
      visibleProgramChoices[0].removeAttribute('disabled');
      programFamilySelect2.next().find('.select2-selection').addClass('completed');
      programSelect.selectedIndex = 0;
      campusSelect.selectedIndex = 0;
    } else {
      // If there is no choice available, then uncheck the selected choice to avoid form validation with invalid values
      document.querySelectorAll(programForm + ' option').forEach(function (elm) {
        if (elm.index === 0) {
          elm.parentElement.value = '';
        } else {
          elm.classList.add('hide');
          elm.setAttribute('disabled', 'disabled');
        }
      }); // Rare but possible case : the program family have programs without campus
      // Clean the campus column in this case

      document.querySelectorAll(campusForm + ' option').forEach(function (elm) {
        if (elm.index === 0) {
          elm.parentElement.value = '';
        } else {
          elm.classList.add('hide');
          elm.setAttribute('disabled', 'disabled');
        }
      });
    }

    $(programSelect2).select2('destroy');
    $(programSelect).select2();
    $(programSelect2).trigger('change');
  }); // Program inputs event listener

  programChoices.forEach(function (elm, key) {
    // If program is a parent, don't bind this event below
    programSelect2.on('change', function (evt) {
      var choosenProgramId = evt.target.value; // Hide campuses which are not children of the program

      changeCampus(choosenProgramId);

      if (programSelect2.val() != null) {
        programSelect2.next().find('.select2-selection').addClass('completed');
      }

      $(campusSelect2).select2('destroy');
      $(campusSelect).select2();
      $(campusSelect2).trigger('change');
    });
  });
  $('#BrochureV2Type_IdFamilyProgram, #BrochureV2Type_IdProgram, #BrochureV2Type_IdCampus').on('select2:close', function () {
    this.dispatchEvent(new Event('blur'));
  }).each(function () {
    $(this).closest('.element').find('.select2-selection').toggleClass('completed', $(this).val().length > 0);
  });
});

},{}]},{},[1]);
